/**
 * The address for the Faucet contract. Useful for lobbies.
 */
export const REGISTRY_ADDRESS = '0x1A28A0e5a94c1C4276538828C0FcD4604e4312dc';
